import type { XrefPumps } from "@/composables/forms/formTypes";
import type { MaybeRef } from "@vueuse/core";

import { ref, computed } from "vue";

export const usePumpRowHeader = (
  xrefPump: MaybeRef<XrefPumps[number]>,
  ascendingOrderPumps: MaybeRef<XrefPumps>
) => {
  const _xrefPump = ref(xrefPump);
  const _ascendingOrderPumps = ref(ascendingOrderPumps);
  const index = computed(() =>
    _ascendingOrderPumps.value.findIndex(p => p.id === _xrefPump.value.id)
  );
  return computed(() => {
    if (index.value === 0) {
      return "Primary Pump Type";
    } else if (index.value === _ascendingOrderPumps.value.length - 1) {
      return "Bottom Taper Pump Type";
    } else if (index.value > 0) {
      return "Middle Taper Pump";
    } else {
      return null;
    }
  });
};
